<app-card>
  <div class="row justify-content-center">
    <div class="col-md-5">
      <h3 class="text-center mt-3 mb-0">Municipality Details</h3>
      <form (ngSubmit)="onSubmit()" #ngForm="ngForm" #userForm="ngForm" [ngClass]="validated?'was-validated':''" style="z-index: 1000;">

        <div class="input-group mb-3">
          <select type="text" class="form-control" appProvince name="province" [(ngModel)]="item.province" required></select>
          <div class="invalid-feedback">
            Province is required
          </div>
        </div>
        <div class="input-group mb-3">
          <input type="text" class="form-control"  name="name" [(ngModel)]="item.name" required>
          <div class="invalid-feedback">
            Name is required
          </div>
        </div>
        <div class="d-grid gap-2">
          <button class="btn btn-primary btn-block mb-5" type="submit">Save</button>
        </div>
      </form>
    </div>
  </div>
</app-card>
